module.exports = __webpack_public_path__ + "img/tu1.b02c654d.png";